import React from 'react'
import './Home.css'

const Home = () => {
  const programs = [
    {
      id: 'ProjectPengyou',
      name: 'Project Pengyou',
      description: 'Mobilizing a rising generation of U.S.-China bridge-builders',
      image: '/images/pg-projectpengyou.png'
    },
    {
      id: 'fivebuckets',
      name: 'The "Five Buckets" Model',
      description: 'Mapping China\'s nonprofit giving landscape',
      image: '/images/pg-fivebuckets.png'
    },
    {
      id: 'chinamedicalboard',
      name: 'Philanthropy for Health in China (China Medical Board)',
      description: 'An academic exploration of Chinese medical philanthropy by leading experts in the field',
      image: '/images/pg-chinamedicalboard.png'
    },
    {
      id: 'chinanonprofitweibodigest',
      name: 'China Nonprofit Weibo Digest',
      description: 'Capturing and translating frontline voices and monthly nonprofit news',
      image: '/images/pg-chinanonprofitweibodigest.png'
    },
    {
      id: 'thechinafoundationcenter',
      name: 'The China Foundation Center',
      description: 'Catalyzing philanthropic transparency in China',
      image: '/images/pg-thechinafoundationcenter.png'
    },
    {
      id: 'thegreatgreeninitiative',
      name: 'The Great Green Initiative',
      description: 'Mobilizing 300 grassroots climate events across China in a single day',
      image: '/images/pg-thegreatgreeninitiative.png'
    }
  ]

  const newsItems = [
    {
      title: 'U.S.-China Youth Entrepreneurship and Economic Opportunities Forum in Shenzhen, China',
      date: 'December 9, 2017',
      excerpt: 'Last week, from December 5-8, 2017, Our Executive Director, Alyssa Farrelly, attended the U.S.-China Youth Entrepreneurship and Economic Opportunities Forum in Shenzhen, China. This was the inaugural year of the forum, which was sponsored by US Department of State and All-Youth China Federation. As part of this Forum, 50 American and 50 Chinese emerging leaders in entrepreneurship and...'
    },
    {
      title: 'Young Leaders Celebrate U.S.-China Friendship and Cross-Cultural Understanding on Pengyou Day 2017',
      date: 'November 26, 2017',
      excerpt: 'November 16 was our fourth annual national Pengyou Day! Young leaders all across the U.S and China held events to promote U.S.-China relations and encourage cross-cultural exchange and friendships. Over 100 campuses including Project Pengyou Chapters and Asia Society Confucius classrooms participated in conjunction with the U.S. State Department\'s International Education Week. The nationwide campaign celebrated U.S.-China...'
    },
    {
      title: 'Building China into Your Career: Expert Perspectives from the Classroom to the Workplace',
      date: 'November 7, 2017',
      excerpt: 'On Monday, November 6th, Project Pengyou co-hosted a special panel event at the Hotel Jen Beijing with the Johns Hopkins University School of Advanced International Studies (SAIS) and the Hopkins-Nanjing Center (HNC) on how to build China into your career. This marked the third event in an annual series with SAIS (see the 2015 and...'
    }
  ]

  return (
    <div className="home-page">
      {/* Hero Banner */}
      <section 
        className="banner"
        style={{
          backgroundImage: 'url(/images/banner-home.jpg)'
        }}
      >
        <div className="wrapper">
          <div className="banner-content">
            <div className="gb-logo"></div>
            <p>Diverse Cultures... Shared Humanity...</p>
          </div>
        </div>
      </section>

      {/* Mission Section */}
      <section className="section mission-section">
        <div className="wrapper">
          <div className="section-header">
            <h2>MISSION</h2>
          </div>
          <blockquote className="quote">
            <p>Our mission is to build bridges to China that empower individuals and organizations to serve, inspire and transform lives.</p>
          </blockquote>
        </div>
      </section>

      {/* Programs Section */}
      <section id="programs" className="section programs-section">
        <div className="wrapper">
          <div className="section-header">
            <h2>HIGHLIGHTED PROGRAMS</h2>
          </div>
          <div className="programs-grid">
            {programs.map((program) => (
              <div key={program.id} className="card program-card">
                <div className="program-image">
                  <img src={program.image} alt={program.name} />
                </div>
                <div className="program-content">
                  <h3>{program.name}</h3>
                  <p>{program.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* News Section */}
      <section className="section news-section">
        <div className="wrapper">
          <div className="section-header">
            <h2>LATEST NEWS</h2>
          </div>
          <div className="news-grid">
            {newsItems.map((news, index) => (
              <article key={index} className="news-item">
                <h3>{news.title}</h3>
                <div className="news-date">{news.date}</div>
                <p>{news.excerpt}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

    </div>
  )
}

export default Home